import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Button,
  Checkbox,
  Autocomplete,
  TextField,
  ListItemText,
  useMediaQuery,
  Chip,
} from "@mui/material";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import VoucherModal from "./Component/VoucherModal";

import { confirmAlert } from "react-confirm-alert"; // Import
import {
  Get_PutAway_DOCUMENTNO_GETROW,
  Get_PutAway_GetStatusDetails,
  GetAttributes,
} from "./PutAwayGenerationAction";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  PutAway_PutAwayValidation,
  PutAway_Reverse,
  PutAway_Save,
} from "../../Server/ApiV2";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import MultiUserModal from "./Component/MultiUserModal";

const PutAwayGeneration = () => {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const ALL_OPTION = { UId: "ALL", Name1: "Select All" };

  const navigate = useNavigate();
  // const location = useLocation();
  // const {
  //   VocTyp = "",
  //   VocNo = "",
  //   RefNo = "",
  // } = !!location.state
  //   ? location.state
  //   : {
  //       VocTyp: "",
  //       VocNo: "",
  //       RefNo: "",
  //     };

  const saved = JSON.parse(localStorage.getItem("putawayData")) || {};
  const { VocTyp = "", VocNo = "", RefNo = "" } = saved;

  const init = {
    voucherType: "",
    voucherNo: "",
    grnStatus: "",
    putAwayStatus: "",
    status: "",
    mode: "A",
    selectedUsers: [],
    selectAll: false,
    btnSave: true,
    btnPost: true,
    btnReverse: false,
  };
  const [formState, setFormState] = useState(init);
  const [sOpen, setOpen] = useState(false);

  const [voucherTypes, setVocherType] = useState([]);

  const [userList, setUserList] = useState([]);

  // console.log("userList", userList);

  const handleChange = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  //Moadl start

  const [modalOpen, setModalOpen] = useState(false);

  //Moadl end

  const VocNoSearch = async () => {
    if (formState.voucherNo !== "") {
      let resp = await Get_PutAway_DOCUMENTNO_GETROW(
        formState.voucherType,
        formState.voucherNo,
        "Y"
      );
      if (resp.length > 0) {
        console.log(resp);
        setFormState((prev) => ({
          ...prev,
          voucherNo: resp[0].AcCd,
        }));
        await Get_PutAway_GetStatusDetails(
          formState.voucherType,
          resp[0].AcCd,
          setFormState,
          userList
        );
      } else {
        setModalOpen(true);
      }
    } else {
      setModalOpen(true);
    }
  };
  const onload = async () => {
    let iAttributes = await GetAttributes(setVocherType, setUserList);
    console.log(iAttributes);
    if (VocTyp != "" && VocNo != "") {
      setFormState((pre) => ({
        ...pre,
        voucherType: VocTyp,
        voucherNo: VocNo,
      }));

      await Get_PutAway_GetStatusDetails(
        VocTyp,
        VocNo,
        setFormState,
        iAttributes?.Users
      );
    } else {
      setFormState((pre) => ({
        ...pre,
        voucherType: iAttributes?.VoucherTypes[0]?.VocTyp,
      }));
    }
  };
  const fValidationHead = () => {
    let iRes = true;

    if (
      formState.voucherNo === "" ||
      formState.voucherNo === null ||
      formState.voucherNo === undefined
    ) {
      fAlertToast("FAILED", "voucher number should not be empty");
      iRes = false;
    }
    if (
      formState.voucherType === "" ||
      formState.voucherType === null ||
      formState.voucherType === undefined
    ) {
      fAlertToast("FAILED", "voucher type should not be empty");
      iRes = false;
    }
    if (
      formState.mode === "" ||
      formState.mode === null ||
      formState.mode === undefined
    ) {
      fAlertToast("FAILED", "select at one radio button");
      iRes = false;
    }

    if (formState.grnStatus !== "POST") {
      fAlertToast("FAILED", "GRN status should be post");

      iRes = false;
    }
    if (formState.putAwayStatus === "POST") {
      fAlertToast("FAILED", "Put-Away is posted Modification denied");
      iRes = false;
    }
    if (formState.selectedUsers.length === 0) {
      fAlertToast("FAILED", "Select atleast one user");
      iRes = false;
    }

    return iRes;
  };

  const SaveHead = async (xStatus) => {
    let obj = {
      VocTyp: formState.voucherType,
      VocNo: formState.voucherNo,
      rbAutoChecked: formState.mode == "A",
      lstUsers: formState.selectedUsers,
      xStatus: xStatus,
    };
    let resp = await PutAway_Save(fcheck_null_undefine_replace_empty(obj));
    if (resp?.status === 200) {
      fAlertToast(
        "SUCCESS",
        `${xStatus == "ENTER" ? "Saved successfully" : "Posted successfully"}`
      );

      if (xStatus == "POST") {
        setFormState((obj) => ({
          ...obj,
          status: "POST",
        }));
      }
    }
  };

  const ValidationServerSide = async () => {
    let obj = {
      VocTyp: formState.voucherType,
      VocNo: formState.voucherNo,
      rbAutoChecked: formState.mode == "A",
    };
    let resp = await PutAway_PutAwayValidation(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      return true;
    }
  };
  const ValidationPost = async () => {
    let obj = {
      VocTyp: formState.voucherType,
      VocNo: formState.voucherNo,
      rbAutoChecked: formState.mode == "A",
      rbManualChecked: formState.mode == "M",
    };
    let resp = await PutAway_PutAwayValidation(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      return true;
    }
  };
  const Get_PutAway_Reverse = async () => {
    let obj = {
      VocTyp: formState.voucherType,
      VocNo: formState.voucherNo,
      rbAutoChecked: formState.mode == "A",
      rbManualChecked: formState.mode == "M",
    };
    let resp = await PutAway_Reverse(fcheck_null_undefine_replace_empty(obj));
    if (resp?.status === 200) {
      return true;
    }
  };
  const fSave = async (xStatus = "ENTER") => {
    let validation = fValidationHead();
    if (!validation) return;

    let server_Validation = await ValidationServerSide();
    if (!server_Validation) return;
    if (server_Validation) {
      setTimeout(() => {
        confirmAlert({
          title: `Save`,
          message: `Are you want to save?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await SaveHead(xStatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
    }
  };
  const fPost = async (xStatus = "POST") => {
    let validation = fValidationHead();
    if (!validation) return;

    let server_Validation = await ValidationServerSide();
    if (!server_Validation) return;

    let server_Post_Validation = await ValidationPost();
    if (!server_Post_Validation) return;

    if (server_Post_Validation) {
      setTimeout(() => {
        confirmAlert({
          title: `Approve`,
          message: `Are you want to Approve?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await SaveHead(xStatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
    }
  };
  const fReverse = async () => {
    setTimeout(() => {
      confirmAlert({
        title: `${"Reverse"}`,
        message: `Are you want to Reverse?`,
        buttons: [
          {
            className: "alertBtn",
            name: "SaveYes",
            label: "Yes",
            onClick: async () => {
              let server_Validation = await Get_PutAway_Reverse();
              if (!server_Validation) return;

              if (server_Validation) {
                fAlertToast("SUCCESS", "Reversed Successfully");
                setFormState((pre) => ({
                  ...pre,
                  status: "ENTER",
                }));
                return;
              }
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => {
              return;
            },
          },
        ],
      });
    }, 100);
  };

  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;

      let urlPrint =
        webReport?.Val +
        "WMS/WMSINVTransprint?prntyp=" +
        xPrnTyp +
        "&VocTyp=" +
        formState.voucherType +
        "&VocNo=" +
        formState.voucherNo;
      console.log(urlPrint);

      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [
      vRdxDBKernObj?.WEB_REPORT_BASE_URL,
      formState.voucherType,
      formState.voucherNo,
    ]
  );

  const options = useMemo(() => [ALL_OPTION, ...userList], [userList]);

  /** Current value for Autocomplete */
  // const value = useMemo(() => {
  //   if (formState.selectAll) return [ALL_OPTION, ...userList];
  //   return userList?.filter((u) => formState.selectedUsers.includes(u.UId));
  // }, [formState.selectAll, formState.selectedUsers, userList, ALL_OPTION]);

  const value = useMemo(() => {
    if (formState.selectAll) return options;

    return options.filter((opt) => formState.selectedUsers.includes(opt.UId));
  }, [formState.selectAll, formState.selectedUsers, options]);

  const handleUserChange = (_, newValue, reason, details) => {
    const clickedOption = details?.option;

    // 1️⃣ If Select All was clicked
    if (clickedOption?.UId === "ALL") {
      const shouldSelectAll = !formState.selectAll; // toggle

      setFormState((prev) => ({
        ...prev,
        selectAll: shouldSelectAll,
        selectedUsers: shouldSelectAll ? userList.map((u) => u.UId) : [],
      }));
      return;
    }

    // 2️⃣ Handle normal selection/deselection of users
    const filtered = newValue.filter((v) => v.UId !== "ALL");
    const selectedIds = filtered.map((v) => v.UId);

    setFormState((prev) => ({
      ...prev,
      selectAll: selectedIds.length === userList.length,
      selectedUsers: selectedIds,
    }));
  };

  console.log("form", formState);

  // useEffect(() => {
  //   console.log("formState", formState?.selectedUsers);
  // }, [formState?.selectedUsers]);

  useEffect(() => {
    onload();
  }, []);

  return (
    <Box
      sx={{
        p: vMediaQuery ? 0 : 3,
        width: vMediaQuery ? "100%" : 900,
        margin: "0 auto",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Put-Away Generation
      </Typography>

      <Grid container spacing={2}>
        {/* Voucher Type Dropdown */}
        <Grid item xs={6}>
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"1"}
            xLabelText="Voucher Type"
            xValue={formState.voucherType}
            xOnChange={(e) => {
              setFormState((prev) => ({
                ...prev,
                voucherType: e.target.value,
                voucherNo: "",
                grnStatus: "",
                putAwayStatus: "",
                status: "",
                mode: "A",
                selectedUsers: [],
                selectAll: false,
              }));
            }}
            xName={"voucherType"}
            xData={voucherTypes}
            xValueMember={""}
            xDispalyMember={""}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>

        {/* Voucher No with Icon */}
        <Grid item xs={6}>
          <GCToggleSearchV1
            xLabelText="Voucher No"
            xSize="small"
            xName={"voucherNo"}
            xType={"text"}
            xValue={formState.voucherNo}
            xReadOnly={false}
            xOnChange={(e) => {
              handleChange("voucherNo", e.target.value);
              setFormState((prev) => ({
                ...prev,
                voucherNo: e.target.value,
                grnStatus: "",
                putAwayStatus: "",
                status: "",
                mode: "A",
                selectedUsers: [],
                selectAll: false,
              }));
            }} //GCToggleSearch onchange main input
            xOnKeyUp={(e) => {
              if (e.key === "Enter") {
                VocNoSearch();
              } // Trigger modal on Enter key
            }} //GCToggleSearch xOnKeyUp main input
            xMediaQuery={false}
            xonClickbtn={(e) => {
              if (e._reactName === "onClick") {
                VocNoSearch();
              }
            }} // GCToggleSearch onclick icon open div on main screen
          />
        </Grid>

        {/* GRN Status */}
        <Grid item xs={6}>
          <CmpTextFieldV1
            xLabelText="GRN Status"
            xSize="small"
            xValue={formState.grnStatus}
            xType={"text"} // text/number/password
            xName={"grnStatus"}
            xReadOnly={true}
            xOnChange={(e) => handleChange("grnStatus", e.target.value)}
          />
        </Grid>

        {/* PutAway Status */}
        <Grid item xs={6}>
          <CmpTextFieldV1
            xLabelText="PutAway Status"
            xSize="small"
            xValue={formState.putAwayStatus}
            xType={"text"} // text/number/password
            xName={"putAwayStatus"}
            xReadOnly={true}
            xOnChange={(e) => handleChange("putAwayStatus", e.target.value)}
          />
        </Grid>

        {/* Status */}
        <Grid item xs={6}>
          <CmpTextFieldV1
            xLabelText="Status"
            xSize="small"
            xValue={formState.status}
            xType={"text"} // text/number/password
            xName={"status"}
            xReadOnly={true}
            xOnChange={(e) => handleChange("status", e.target.value)}
          />
        </Grid>

        {/* Mode */}
        <Grid item xs={6}>
          <FormControl>
            {/* <FormLabel>Mode</FormLabel> */}
            <RadioGroup
              row
              value={formState.mode}
              onChange={(e) => handleChange("mode", e.target.value)}
              disabled={formState.status === "POST"}
            >
              <FormControlLabel
                value="A"
                disabled={formState.status === "POST"}
                control={<Radio />}
                label="Auto"
              />
              <FormControlLabel
                value="M"
                disabled={formState.status === "POST"}
                control={<Radio />}
                label="Manual"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Users List */}
        <Grid item xs={12}>
          <Autocomplete
            fullWidth
            multiple
            disableCloseOnSelect
            options={options}
            value={value}
            onChange={handleUserChange}
            getOptionLabel={(opt) => opt.Name1}
            // isOptionEqualToValue={(opt, val) => opt.UId === val.UId}
            disabled={formState?.status == "POST"}
            // Hide the chips so the input stays compact
            // renderTags={() => null}
            renderTags={(selected, getTagProps) => (
              <Box
                sx={{
                  maxHeight: 70, // fixed height for chip-area
                  overflowY: "auto", // vertical scrolling
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                }}
              >
                {selected
                  .filter((opt) => opt.UId !== "ALL")
                  .map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.UId}
                      label={option.Name1}
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: "9px",
                        borderRadius: "6px",
                        backgroundColor: "#dddcdcff",
                        color: "#272727ff",
                      }}
                    />
                  ))}
              </Box>
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.UId}>
                <Checkbox
                  // “Select All” gets checked if either explicitly selected
                  // or when every user is selected.
                  checked={
                    option.UId === "ALL"
                      ? formState.selectAll
                      : formState.selectAll || selected
                  }
                />
                <ListItemText primary={option.Name1} />
              </li>
            )}
            // renderInput={(params) => (
            //   <TextField
            //     {...params}
            //     label="Users"
            //     placeholder="Choose users…"
            //     size="small"
            //   />
            renderInput={(params) => {
              const selectedNames = value
                .filter((v) => v.UId !== "ALL")
                .map((v) => v.Name1)
                .join(", ");

              return (
                <TextField
                  {...params}
                  fullWidth
                  label="Users"
                  placeholder="Choose users…"
                  size="small"
                  value={selectedNames} // ← show selected names
                  InputProps={{
                    ...params.InputProps,
                    inputProps: params.inputProps,
                    style: {
                      whiteSpace: "wrap",
                      overflow: "auto",
                    },
                  }}
                />
              );
            }}
            sx={{
              // width: 300,

              "& .MuiInputBase-root": {
                paddingTop: "6px !important",
                paddingBottom: "6px !important",
                alignItems: "flex-start", // allow chips at top
                minHeight: "56px", // textfield height
              },
            }}
          />

          {/* <Typography variant="subtitle1">Users</Typography>
          <List
            dense
            sx={{ maxHeight: 200, overflow: "auto", border: "1px solid #ccc" }}
          >
            {userList?.map((user, index) => (
              <ListItem key={index} dense button>
                <Checkbox
                  checked={formState?.selectedUsers?.includes(user?.UId)}
                  disabled={formState?.status == "POST"}
                  onClick={() => handleUserToggle(user?.UId)}
                />
                <ListItemText primary={user?.Name1} />
              </ListItem>
            ))}
          </List>
          <FormControlLabel
            control={
              <Checkbox
                checked={formState.selectAll}
                onChange={handleSelectAll}
                disabled={formState?.status == "POST"}
              />
            }
            label="Select All"
          /> */}
        </Grid>
        {/* Action Buttons */}
        <Grid
          item
          xs={12}
          sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}
        >
          <Button
            variant="contained"
            disabled={formState.mode == "M"}
            onClick={() => {
              if (
                formState.voucherNo == "" ||
                formState.voucherNo == null ||
                formState.voucherNo == undefined
              ) {
                fAlertToast("FAILED", "Voucher number should not be empty");
              } else if (
                formState.voucherType == "" ||
                formState.voucherType == null ||
                formState.voucherType == undefined
              ) {
                fAlertToast("FAILED", "Voucher type should not be empty");
              } else {
                setOpen(true);
              }
            }}
          >
            Multi - User
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              fPrint("GRNPAWYBINRES");
            }}
          >
            Allocated Bin
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              fPrint("GRNPAWYITMDET");
            }}
          >
            Item Detail
          </Button>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}
        >
          <Button
            disabled={formState.status === "POST"}
            variant="contained"
            color="primary"
            onClick={(e) => {
              fSave("ENTER");
            }}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={formState.status === "POST"}
            onClick={(e) => {
              fPost("POST");
            }}
          >
            Post
          </Button>
          <Button
            variant="contained"
            color="warning"
            disabled={formState.status != "POST"}
            onClick={(e) => {
              fReverse();
            }}
          >
            Reverse
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              setFormState(init);
              setFormState((pre) => ({
                ...pre,
                voucherType: voucherTypes[0]?.VocTyp,
              }));
              navigate("/wmsPutawayGeneration", {
                state: {
                  GRNDocTyp: "",
                  GrnDocNo: "",
                  RefNo: "",
                },
              });
            }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>

      {/* Modal Component */}
      <VoucherModal
        open={modalOpen}
        fCloseSearchModal={(e) => {
          setModalOpen(false);
        }}
        xOnRowClickSearch={async (item) => {
          console.log(item.row);
          setFormState((pre) => ({
            ...pre,
            voucherNo: item.row.AcCd,
          }));
          await Get_PutAway_GetStatusDetails(
            formState.voucherType,
            item.row.AcCd,
            setFormState,
            userList
          );
          setModalOpen(false);
        }}
        xTitle="GRN Search"
        anydata={formState.voucherNo}
        vocType={formState.voucherType}
      />

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      <MultiUserModal
        open={sOpen}
        fCloseSearchModal={() => setOpen(false)}
        xVocType={formState.voucherType}
        xVocNo={formState.voucherNo}
      />
    </Box>
  );
};

export default PutAwayGeneration;
